import NewReleaseMulti from './new-release-multi';

export * from './new-release-multi';
export default NewReleaseMulti;
